import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroApiPaths } from 'Feature/Khodro/ShakhsSales/ApiPaths/KhodroApiPaths';
import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';

export const getEstelamDarsadTakhfif = createAsyncThunk('BimehNameh/estelamDarsadTakhfif', async (query: any) => {
  return await KhodroHttpGetService({
    url: `${KhodroApiPaths.BimehMarkazi.EstelamDarsadTakhfif}`,
    params: query,
  });
});
